import * as _ from 'lodash';

import { Identifiable } from '../identifiable';

export namespace IdObjectValue {
  export type SchemaContractCollection<TSchemaContract> = {
    [id: string]: TSchemaContract | null;
  };
  export type ModelCollection<TModel> = {
    [id: string]: TModel;
  };

  export namespace Crud {
    export interface Updatable extends Identifiable {
      created: boolean;
      deleted: boolean;
    }

    export type IdObjectValueSchemaCollection<TSchemaContract> = {
      [id: string]: TSchemaContract | null;
    };

    export function toIdObjectValueSchemaCollection<
      TModel extends Updatable,
      TSchemaContract
    >(
      values: TModel[],
      translation: (
        value: Omit<TModel, 'id' | 'created' | 'deleted'>
      ) => TSchemaContract = (x) => x as unknown as TSchemaContract
    ): IdObjectValueSchemaCollection<TSchemaContract> {
      const result: IdObjectValueSchemaCollection<TSchemaContract> = {};
      _.forEach(values, (v) => {
        result[v.id] = v.deleted
          ? null
          : (translation(
              _.omit(v, ['id', 'created', 'deleted'])
            ) as unknown as TSchemaContract);
      });
      return result;
    }

    export function toNativeArray<TSchemaContract, TModel extends Updatable>(
      value: IdObjectValueSchemaCollection<TSchemaContract>,
      translation: (value: TSchemaContract & Updatable) => TModel = (x) =>
        x as unknown as TModel
    ): TModel[] {
      const result: TModel[] = [];
      _.forIn(value, (v, k) => {
        if (!v) {
          return;
        }

        result.push(
          translation({
            ...v,
            id: k,
            created: false,
            deleted: false
          })
        );
      });
      return result;
    }

    export function getIdObjectValueSchemaCollectionExcludeNull<
      TSchemaContract
    >(value: IdObjectValueSchemaCollection<TSchemaContract>): {
      [id: string]: TSchemaContract;
    } {
      const result: {
        [id: string]: TSchemaContract;
      } = {};

      for (const k in value) {
        if (value[k]) {
          result[k] = value[k] as TSchemaContract;
        }
      }

      return result;
    }
  }
}
